import React from 'react';
import { isObject } from 'lodash';
import { isArray } from 'util';
import { Tag, Tooltip } from 'antd';

export const urgenzaColorByValue = (urgenzaValue: any) => {
  switch (urgenzaValue) {
    case 0:
      return 'white';

    case 1:
      return 'green';

    case 2:
      return 'yellow';

    case 3:
      return 'red';

    default:
      return '#fff';
  }
};

export const severityOptions = [
  { label: 'lieve', value: 'lieve' },
  { label: 'moderata', value: 'moderata' },
  { label: 'grave', value: 'grave' },
];

export const contactsOptions = [
  { label: 'Email', key: 'email' },
  { label: 'Pec', key: 'pec' },
  { label: 'Mobile', key: 'mobile' },
  { label: 'Telefono', key: 'phone' },
];

export const recurrencyOptions = [
  { label: 'ogni giorno', key: 'daily' },
  { label: 'ogni settimana', key: 'weekly' },
  { label: 'ogni mese', key: 'monthly' },
];

/**
 * Select TURNI
 */
export const shiftOptions = [
  { label: 'Mattina', value: 'M' },
  { label: 'Pomeriggio', value: 'P' },
  { label: 'Notte', value: 'N' },
];

export const addressesOptions = (hasResidenza: any) => {
  return hasResidenza
    ? [
      { label: 'Domicilio', key: 'Domicilio' },
      { label: 'Altro', key: 'Altro' },
    ]
    : [
      { label: 'Domicilio', key: 'Domicilio' },
      { label: 'Residenza', key: 'Residenza' },
      { label: 'Altro', key: 'Altro' },
    ];
};

export const urgenzaBullet = (urgenzaValue: any, label = '') => {
  return (
    <p>
      <span className={'priority-bullet priority-' + urgenzaValue} />
      Priorità {label || urgenzaValue}
    </p>
  );
};

export const urgenzaOptions = [
  {
    key: '0',
    label: urgenzaBullet(0),
  },
  {
    key: '1',
    label: urgenzaBullet(1),
  },
  {
    key: '2',
    label: urgenzaBullet(2),
  },
  {
    key: '3',
    label: urgenzaBullet(3),
  },
];

export const genderOptions = [
  {
    key: 'M',
    label: 'Maschio',
  },
  {
    key: 'F',
    label: 'Femmina',
  },
];

export const placeholderOptions = (text = 'Select') => [
  {
    label: text + ' 1',
    key: 1,
  },
  {
    label: text + ' 2',
    key: 2,
  },
  {
    label: text + ' 3',
    key: 3,
  },
];
export interface SelectOption {
  label: string;
  key: any;
  value: any;
  disabled?: boolean;
}

export const defaultSelectFormatter = (result: any, labelInValue: boolean = false): SelectOption[] => {
  if (result.data) {
    result = result.data;
  }

  const options: SelectOption[] = result.map((dat: any, index: any) => {
    return getSelectLabelValue(dat, index, labelInValue);
  });
  return options;
};

export const getSelectLabelValue = (dat: any, index = 0, debug: boolean = false): SelectOption => {
  if (isObject(dat)) {
    const _dat: any = dat;
    const label =
      _dat.label ??
      _dat.name ??
      _dat.name_it ??
      _dat.text ??
      _dat.label_it ??
      _dat.description_it ??
      _dat.description ??
      _dat.exam_name ??
      '';
    const value =
      _dat.id ??
      _dat.key ??
      _dat.index ??
      _dat.value ??
      _dat.idindex ??
      _dat.idlegend ??
      _dat.exam ??
      'INDEX ' + index;

    let newOpt: any = {
      label: debug ? `${label} -(${value})` : label,
      value,
      key: value,
    };

    if (_dat.disabled) {
      newOpt.disabled = true;
    }

    return newOpt;
  } else {
    return {
      label:
        dat.label ??
        dat.name ??
        dat.name_it ??
        dat.text ??
        dat.label_it ??
        dat.description_it ??
        dat.description ??
        dat.exam_name ??
        dat,
      value: index,
      key: index,
    };
  }
};

export const hasLabelValue = (value: any) => {
  if (!value) return false;
  const hasLabel =
    value.label ??
    value.name ??
    value.name_it ??
    value.text ??
    value.label_it ??
    value.description_it ??
    value.description ??
    false;

  const hasValue =
    value.id ?? value.key ?? value.index ?? value.value ?? value.idindex ?? value.idlegend ?? false;

  return hasLabel && hasValue;
};


export const getDefaulSelectValue = (value: string | [], service: () => any) => {
  //userValues.birth_nation ? () => LocationService.nation({ id: userValues.birth_nation }) : null,
  if (!value) return null;
  let labelValue: any = value;

  if (isObject(value) || isArray(value)) {
    labelValue = getSelectLabelValue(value);
    return labelValue;
  } else {
    return service;
  }
};

export const YesNoOptions = [
  { label: 'Si', value: true },
  { label: 'No', value: false },
];

export const YesNoTextOptions = [
  { label: 'Si', value: 'Si' },
  { label: 'No', value: 'No' },
];

export const YesNoNAOptions = [
  { label: 'SI', value: 'yes' },
  { label: 'NO', value: 'no' },
  { label: 'N.A.', value: 'na' },
];

export const YesNAOptions = [
  { label: 'SI', value: 'yes' },
  { label: 'N.A.', value: 'na' },
];

export const NoPossibileIdoneoEfficace = [
  { label: 'Non Possibile', value: 'non_possibile' },
  { label: 'Non Idoneo', value: 'non_idoneo' },
  { label: 'Non Efficace', value: 'non_efficace' },
];
export const SNOptions = [
  { label: 'Si', value: 'S' },
  { label: 'No', value: 'N' },
];

export const DisagioOptions = [
  'INSUFF/MEDIOCRE',
  'SUFF/ABBASTANZA',
  'ADEGUATO/BUONO ',
  'MOLTO ADEGUATO/ECCELLENTE',
];

export const DisagioRadios = [
  {
    label: (
      <Tooltip title="INSUFF/MEDIOCRE">
        <>
          <Tag color="red">1 </Tag>
          <em>INSUFF / MEDIOCRE</em>
        </>
      </Tooltip>
    ),
    value: 1,
  },
  {
    label: (
      <Tooltip title="SUFF/ABBASTANZA">
        <>
          <Tag color="orange">2 </Tag>
          <em>SUFF / ABBASTANZA</em>
        </>
      </Tooltip>
    ),
    value: 2,
  },
  {
    label: (
      <Tooltip title="ADEGUATO/BUONO">
        <>
          <Tag color="blue">3 </Tag>
          <em>ADEGUATO / BUONO</em>
        </>
      </Tooltip>
    ),
    value: 3,
  },
  {
    label: (
      <Tooltip title="MOLTO ADEGUATO/ECCELLENTE">
        <>
          <Tag color="green">4 </Tag>
          <em>MOLTO ADEGUATO / ECCELLENTE</em>
        </>
      </Tooltip>
    ),
    value: 4,
  },
];

export const DisagioRadiosTooltips = [
  {
    label: (
      <Tooltip title="INSUFF/MEDIOCRE">
        <div className="radioRate"> 1 </div>
      </Tooltip>
    ),
    value: 1,
  },
  {
    label: (
      <Tooltip title="SUFF/ABBASTANZA">
        <div className="radioRate"> 2 </div>
      </Tooltip>
    ),
    value: 2,
  },
  {
    label: (
      <Tooltip title="ADEGUATO/BUONO">
        <div className="radioRate"> 3 </div>
      </Tooltip>
    ),
    value: 3,
  },
  {
    label: (
      <Tooltip title="MOLTO ADEGUATO/ECCELLENTE">
        <div className="radioRate"> 4 </div>
      </Tooltip>
    ),
    value: 4,
  },
];

export const createStringOptions = (options: string[]) => {
  return options.map((opt) => ({ label: opt, value: opt }));
};

export const getLabelById = (id: any, options: SelectOption[] | any[], fallback = '') => {
  let label: string = options.find((t) => t.value === id)?.label || fallback;

  return label;
};

export const convertDropDownToFilter = (dropDown: any) => {
  let res: any[] = [];
  Object.keys(dropDown).forEach(function (item) {
    const el = { text: dropDown[item], value: item };
    res.push(el);
  })
  return res;
};
